import { ReactElement } from 'react'

import { Select, Spin } from 'antd'

import { getAdGroups } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { SEARCH_RESULTS_PER_QUERY } from 'configuration/typeahead'
import { useTypeahead } from 'hooks'
import { AdGroup } from 'types'

interface Props {
    value?: string
    onChange: (value: string) => void
}

const AdGroupSearchSelect = ({ value, onChange }: Props): ReactElement => {
    const [options, loading, onSearch, resetLoadingState] =
        useTypeahead<AdGroup>({
            apiSearchFunc: (query) =>
                getAdGroups(
                    {
                        limit: SEARCH_RESULTS_PER_QUERY,
                        name__similar: query,
                        'state!': 'archived',
                    },
                    { headers: { noCount: true } }
                ),
            optionFormatter: (adGroup) => ({
                value: adGroup.id,
                label: adGroup.name,
                metadata: adGroup.campaign.name,
            }),
        })

    return (
        <Select
            filterOption={false}
            placeholder="Search Ad Groups..."
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            onSelect={resetLoadingState}
            showSearch
            style={{ width: '100%' }}
            value={value}
        >
            {options.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                    {option.label} <i>({option.metadata})</i>
                </Select.Option>
            ))}
        </Select>
    )
}

export default AdGroupSearchSelect
